import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function MiniCards({ imgg, txt, txt2 }) {
  const { t } = useTranslation();
  return (
    <div>
      <Container>
        <Card sx={{ borderRadius: "10px", padding: "5px", width: "290px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CardMedia
              image={imgg}
              component="img"
              sx={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "100%",
                backgroundColor: "#EBF6FF",
              }}
            />
            <CardContent
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontWeight: "bold", color: "#1D2877", fontSize: "18px" }}
              >
                {t(txt)}
              </Typography>
              <Typography sx={{ color: "#1D2877" }}>{t(txt2)}</Typography>
            </CardContent>
          </div>
        </Card>
      </Container>
    </div>
  );
}
